/** Categorical batch signal when any procedure in a tRPC HTTP response returned UNAUTHORIZED (including HTTP 207). */
export const TRPC_UNAUTHORIZED_BATCH_HEADER = "x-shelfcycle-trpc-unauthorized";

export const TRPC_UNAUTHORIZED_BATCH_HEADER_VALUE = "1";

export const TRPC_UNAUTHORIZED_CODE = "UNAUTHORIZED";

export function isTrpcUnauthorizedCode(value: unknown): boolean {
  return typeof value === "string" && value === TRPC_UNAUTHORIZED_CODE;
}

export function isTrpcUnauthorizedBatchResponseHeader(value: string | null): boolean {
  return value === TRPC_UNAUTHORIZED_BATCH_HEADER_VALUE;
}
